<template>
	<!-- Main Wrapper -->
	<div class="main-wrapper">
		<layout-header></layout-header>
		<layout-sidebar></layout-sidebar>

		<!-- Page Wrapper -->
		<div class="page-wrapper">
			<div class="content container-fluid">
				<componentheader :title="title" />

				<div class="row">
					<div class="col-xl-3 col-md-4">
						<settingsidebar />
					</div>

					<div class="col-xl-9 col-md-8">
						<div class="card">
							<div class="card-header">
								<h5 class="card-title">Basic information</h5>
							</div>
							<div class="card-body">
								<!-- Form -->
								<b-form @submit="onSubmit">
									<div class="row form-group">
										<label for="name" class="col-sm-3 col-form-label input-label"></label>
										<div class="col-sm-9">
											<div class="d-flex align-items-center">
												<label
													class="avatar avatar-xxl profile-cover-avatar m-0"
													for="edit_img"
												>
													<img
														v-if="imageUrl"
														id="avatarImg"
														class="avatar-img"
														:src="imageUrl"
														alt="Profile Image"
													/>
													<img
														v-else
														id="avatarImg"
														class="avatar-img"
														src="@/assets/img/profiles/avatar-02.jpg"
														alt="Profile Image"
													/>
													<input @change="onChangeFile" type="file" id="edit_img" />
													<span class="avatar-edit">
														<i
															class="feather feather-edit avatar-uploader-icon shadow-soft"
														></i>
													</span>
												</label>
											</div>
										</div>
									</div>
									<div class="row form-group">
										<label for="name" class="col-sm-3 col-form-label input-label"
											>Name</label
										>
										<div class="col-sm-9">
											<b-form-input
												type="text"
												v-model="form.name"
												class="form-control"
												id="name"
												placeholder="Your Name"
											/>
										</div>
									</div>
									<div class="row form-group">
										<label for="name" class="col-sm-3 col-form-label input-label"
											>Email</label
										>
										<div class="col-sm-9">
											<b-form-input
												disabled
												type="text"
												v-model="mail"
												class="form-control"
												id="name"
												placeholder="Your Name"
											/>
										</div>
									</div>
									<div class="row form-group">
										<label for="phone" class="col-sm-3 col-form-label input-label"
											>Phone <span class="text-muted">(Optional)</span></label
										>
										<div class="col-sm-9">
											<input
												type="tel"
												v-model="form.phone"
												@input="getFormattedNumber"
												ref="phoneInputRef"
												class="form-control"
												id="phone"
												placeholder="Your phone number"
											/>
										</div>
									</div>
									<div class="row form-group">
										<label for="location" class="col-sm-3 col-form-label input-label"
											>Location</label
										>
										<div class="col-sm-9">
											<div class="mb-3">
												<b-form-select class="form-control" v-model="form.country">
													<b-form-select-option :value="null"
														>Your country</b-form-select-option
													>
													<b-form-select-option
														v-for="(country, index) in Countries"
														:key="index"
														:value="country.isoCode"
														>{{ country.name }}</b-form-select-option
													>
												</b-form-select>
											</div>
											<b-form-select class="form-control" v-model="form.state">
												<b-form-select-option :value="null"
													>Your state</b-form-select-option
												>
												<b-form-select-option
													v-for="(state, index) in States"
													:key="index"
													:value="state.name"
													>{{ state.name }}</b-form-select-option
												>
											</b-form-select>
										</div>
									</div>
									<div class="row form-group">
										<label for="addressline1" class="col-sm-3 col-form-label input-label"
											>Address</label
										>
										<div class="col-sm-9">
											<b-form-input
												type="text"
												v-model="form.address"
												class="form-control"
												id="addressline1"
												placeholder="Your address"
											/>
										</div>
									</div>
									<div class="row form-group">
										<label for="zipcode" class="col-sm-3 col-form-label input-label"
											>Zip code</label
										>
										<div class="col-sm-9">
											<b-form-input
												type="text"
												v-model="form.postal_code"
												class="form-control"
												id="zipcode"
												placeholder="Your zip code"
											/>
										</div>
									</div>
									<div class="row form-group">
										<label
											for="zipcode"
											class="col-sm-3 col-form-label input-label"
										></label>
										<div class="col-sm-9">
											<span>Referral code:</span>
											<b-badge class="py-2 ms-2" variant="secondary"
												><p>{{ user1?.referral_code }}</p></b-badge
											>
											<span class="ms-2"
												><b-button
													@click="copyReferralCode(user1?.referral_code)"
													v-b-tooltip.hover
													title="Copy code"
													variant="outline-none"
												>
													<i class="feather feather-copy"></i> </b-button
											></span>
										</div>
									</div>
									<div class="text-end">
										<b-button :disabled="isLoading" type="submit" variant="primary">
											<span
												v-if="isLoading"
												class="spinner-border spinner-border-sm me-1"
												role="status"
												aria-hidden="true"
											></span>
											<span v-if="!isLoading">Save Changes</span>
											<span v-if="isLoading">Updating...</span>
										</b-button>
									</div>
								</b-form>
								<!-- /Form -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /Page Wrapper -->
	</div>
	<!-- /Main Wrapper -->
</template>
<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { Country, State } from "country-state-city";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });
import intlTelInput from "intl-tel-input";

const title = "Settings";
const store = useStore();
const Countries = ref(null);
const user = ref(null);
const isLoading = ref(false);
const mail = ref(null);
const phoneInputRef = ref(null);
let iti;

const form = ref({
  name: "",
  address: "",
  image: "",
  postal_code: "",
  phone: "",
  country: null,
  state: null,
});

// Formating the phone number
const getFormattedNumber = () => {
  if (iti) {
    const formattedNumber = iti.getSelectedCountryData();

    const firstDigit = form.value.phone.charAt(0);
    if (
      form.value.phone.length === 11 &&
      firstDigit != "+" &&
      firstDigit == "0"
    ) {
      form.value.phone = `+${formattedNumber.dialCode} ${form.value.phone.slice(
        1
      )}`;
    } else if (form.value.phone.length === 11 && firstDigit != "+") {
      form.value.phone = `+${formattedNumber.dialCode} ${form.value.phone}`;
    }
  }
};

const user1 = computed(() => {
  return store.getters["auth/user"];
});

const States = computed(() => {
  return State.getStatesOfCountry(form.value.country);
});

const imageUrl = ref("");

const onChangeFile = (event) => {
  imageUrl.value = URL.createObjectURL(event.target.files[0]);
  form.value.image = event.target.files[0];
};

const onSubmit = () => {
  if (form.value.phone !== "" && form.value.phone !== null) {
    getFormattedNumber();
  }
  isLoading.value = true;
  store
    .dispatch("settings/updateProfile", form.value)
    .then(() => {
      isLoading.value = false;
      store.dispatch("auth/getUser");
    })
    .catch(() => {
      isLoading.value = false;
    });
};

// Copy referral code
const copyReferralCode = (code) => {
  if (!navigator.clipboard) {
    toast.error("Clipboard API is not supported in this browser.");
    return;
  }

  navigator.clipboard
    .writeText(code)
    .then(() => {
      toast.success("Code copied to clipboard");
    })
    .catch(() => {
      toast.error("Failed to copy code to clipboard");
    });
};

onMounted(() => {
  Countries.value = Country.getAllCountries();
  user.value = JSON.parse(localStorage.getItem("user"));
  form.value = {
    name: user.value.name,
    address: user.value.address,
    image: "",
    postal_code: user.value.postal_code,
    phone: user.value.phone,
    country: user.value.country,
    state: user.value.state,
  };

  iti = intlTelInput(phoneInputRef.value, {
    nationalMode: true,
    autoPlaceholder: "aggressive",
    formatOnDisplay: true,
    autoInsertDialCode: true,
  });

  fetch("https://ipapi.co/json/")
    .then((response) => response.json())
    .then((data) => {
      const countryCode = data.country_code;
      iti.setCountry(countryCode);
    })
    .catch((error) => {
      console.error("Error fetching IP data:", error);
    });

  mail.value = user.value.email;
  imageUrl.value = user.value.image;
});
</script>
